<footer class="footer-section">
  <div class="footer-content">
    <div class="footer-grid">
      <!-- Brand Column -->
      <div class="brand-column">
        <div class="logo-wrapper">
          <img
            src="assets/shiv-sewa-logo.svg"
            alt="ShivSewa Logo"
            class="shivsewa-logo"
            style="width: 60%"
          />
        </div>

        <!-- Social Media Icons -->
        <div class="social-icons">
          <a href="https://www.facebook.com/profile.php?id=61584510434900" class="social-link" aria-label="Facebook">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
              />
            </svg>
          </a>
          <a href="https://www.instagram.com/shivsewacabservice/" class="social-link" aria-label="Instagram">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
              />
            </svg>
          </a>
        </div>

        <!-- Description -->
        <p class="brand-description">
          Travel with local expertise and guaranteed comfort. Request a quote
          for reliable transfers, corporate fleets, and outstation trips from
          Mumbai.
        </p>
      </div>

      <!-- Company Column -->
      <div class="nav-column">
        <h3 class="column-title">Company</h3>
        <ul class="nav-links">
                        <li *ngFor="let link of companyLinks">
                      <a
              href="#"
              (click)="scrollTo(link.id!); $event.preventDefault()"
              class="nav-link">
              {{ link.label }}</a>
          </li>
        </ul>
      </div>

      <!-- Services Column -->
      <div class="nav-column">
        <h3 class="column-title-hidden" *ngIf="serviceLinks.length >0">Services</h3>
        <ul class="nav-links">
          <li *ngFor="let link of serviceLinks">
            <a [href]="link.url" class="nav-link">{{ link.label }} </a>
          </li>
        </ul>
      </div>

      <!-- Contact Column -->
      <div class="contact-column">
        <h3 class="column-title contact-align">Contact Us</h3>
        <div class="contact-list">
          <div class="contact-item" *ngFor="let contact of contactInfo">
  <div class="contact-icon">
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    >
      <ng-container [ngSwitch]="contact.icon">
        <!-- Location Icon -->
        <g *ngSwitchCase="'location'">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </g>

        <!-- Phone Icon -->
        <path
          *ngSwitchCase="'phone'"
          d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
        ></path>

        <!-- Email Icon -->
        <g *ngSwitchCase="'email'">
          <path
            d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
          ></path>
          <polyline points="22,6 12,13 2,6"></polyline>
        </g>
      </ng-container>
    </svg>
  </div>

  <div class="contact-info">
    <span class="contact-label">

      <!-- Location -->
      <a style="text-decoration: none; color: #AAAAAA;" *ngIf="contact.icon === 'location'"
         [href]="'https://www.google.com/maps/search/?api=1&query=' + contact.label"
         target="_blank">
        {{ contact.label }}
      </a>

      <!-- Phone -->
      <a style="text-decoration: none; color: #AAAAAA;" *ngIf="contact.icon === 'phone'"
         [href]="'tel:' + contact.label">
        {{ contact.label }}
      </a>

      <!-- Email -->
      <a style="text-decoration: none; color: #AAAAAA;" *ngIf="contact.icon === 'email'"
         [href]="'mailto:' + contact.label">
        {{ contact.label }}
      </a>

    </span>
  </div>
</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Bottom -->
  <div class="footer-bottom">
    <p class="copyright">© 2026 Shiv Sewa Cab Services Inc</p>
    <p class="copyright mt-2">
  Designed and Developed by
  <a href="https://www.credencesoft.in/" target="_blank" rel="noopener noreferrer">
    CredenceSoft
  </a>
  and Powered By
  <a href="https://bookonepms.com/" target="_blank" rel="noopener noreferrer">
    BookOne
  </a>
</p>
  </div>
</footer>
